module.exports = __webpack_public_path__ + "img/huace19.60813296.jpg";